import { MDBBtn, MDBCol, MDBRow, MDBInput } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import $ from 'jquery'
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.min.js'
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css'

const ModalCrearContratoControlDevice = ({setDataSaving, onClose}) => {
    const [ubicacion, setUbicacion] = useState('')
    const [fechaLocal, setFechaLocal] = useState('')
    const [saving, setSaving] = useState(false)
    const fechaHoraRef = useRef(null)

    const pad = (n) => String(n).padStart(2, '0')
    const nowLocalStr = () => {
        const d = new Date()
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    }

    useEffect(() => {
        const currentDateTime = nowLocalStr()
        $.datetimepicker.setLocale('en')

        $(fechaHoraRef.current).datetimepicker({
            format: 'Y-m-d H:i',
            step: 30,
            value: currentDateTime,
            timepicker: true,
            datepicker: true,
            onChangeDateTime: (dp, $input) => setFechaLocal($input.val()),
        })

        setFechaLocal(currentDateTime)
        return () => $(fechaHoraRef.current).datetimepicker('destroy')
    }, [])

    const handleSubmit = () => {
        console.log('Ubicación:', ubicacion)
        console.log('Fecha/Hora Local:', fechaLocal)
        setDataSaving({ubicacion, fechaLocal});
    }

    return (
        <>
            <MDBRow className="g-3">
                {/* Full width */}
                <MDBCol xs="12">
                    <label className="form-label">UBICACIÓN:</label>
                    <MDBInput
                        className="w-100"
                        value={ubicacion}
                        onChange={(e) => setUbicacion(e.target.value)}
                        size="sm"
                        style={{ boxSizing: 'border-box', height: '38px' }}
                    />
                </MDBCol>

                <MDBCol xs="12">
                    <label className="form-label">FECHA/HORA INICIO:</label>
                    <input
                        ref={fechaHoraRef}
                        type="text"
                        className="form-control form-control-sm w-100"
                        placeholder="YYYY-MM-DD HH:mm"
                        onChange={(e) => setFechaLocal(e.target.value)}
                        style={{ boxSizing: 'border-box', height: '38px' }}
                    />
                </MDBCol>
                <div className="d-flex justify-content-end">
                    <button className='btn-primary-modals-maestros' onClick={handleSubmit}>
                        {saving ? 'Guardando...' : 'Enviar'}
                    </button>
                </div>
            </MDBRow>
        </>
    )
}

export default ModalCrearContratoControlDevice
